import { useEffect, useState } from 'react';
import { api, getToken } from '../api.js';

// On mount, if a session token exists, hydrate saved answers + enrolled (+ purchase
// plan/role, + the coach-granted additional-information gate) from the server
// (GET /api/ntq). Returns { ready, resumed } so the flow can
// wait before picking a start screen. Degrades to a fresh local session when offline.
export function useResume(applyAnswers, setEnrolled, applyMeta) {
  const [ready, setReady] = useState(false);
  const [resumed, setResumed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!getToken()) {
      setReady(true);
      return () => { cancelled = true; };
    }
    api.get('/ntq')
      .then((d) => {
        if (cancelled) return;
        if (d.answers && Object.keys(d.answers).length) {
          applyAnswers(d.answers);
          setResumed(true);
        }
        setEnrolled(!!d.enrolled);
        // The coach gate rides with plan/role rather than as another positional
        // setter: this is the mount-time path, and dropping it here is what kept the
        // Additional Information section hidden on a plain page reload.
        if (applyMeta) {
          applyMeta({
            plan: d.plan || null,
            role: d.role || null,
            additionalInfoEnabled: !!d.additional_info_enabled,
          });
        }
      })
      .catch(() => { /* offline — fresh session */ })
      .finally(() => { if (!cancelled) setReady(true); });
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { ready, resumed };
}
